// **************************************************************
// *
// * Configuration for all UI visibility settings, for every mode.
// *
// **************************************************************

import {imageUrls} from 'Shared'
import { TestTemplate, TestResults, Professions, Question, Answer, MainCategories, SubCategories } from 'Models'


export default {
    computed: {
        currentModeConfig()
        {
            let current = this.currentConfig

            if(!this.isResultsView)
                return current.testArea

            if(this.isSelfRatingView || this.isPerformanceSummaryView)
                return current.preResultsArea

            if(!this.isSelfRatingView && !this.isPerformanceSummaryView)
                return current.resultsArea
        },

        currentConfig()
        {
            let current = this.testConfig

            if(this.isRevision)         current = this.revisionConfig
            if(this.isRevisionResults)  current = this.revisionResultsConfig
            if(this.isBookmarkRevision) current = this.bookmarkRevisionConfig
            if(this.isDemo)             current = this.demoConfig
            if(this.isExercise)        current = this.exerciseConfig
            if(this.isTestMode)         current = this.testConfig

            return current
        },

        demoConfig()
        {
            let amendedConfig = this.baseConfig()
                amendedConfig.resultsArea.showBuyLicencesBtn = this.isMainCategoriesResultsView

            return amendedConfig
        },

        exerciseConfig()
        {
            let amendedConfig = this.baseConfig()
                amendedConfig.testArea.showMainNav          = true
                amendedConfig.testArea.breadCrumbIcon       = imageUrls.navIcons.exerciseIcon
                amendedConfig.testArea.breadCrumbLeftTitle  = 'Übungsmodus'
                amendedConfig.testArea.breadCrumbRightTitle = Professions.getSelected().title()

                amendedConfig.testArea.showOverallTestTimer = false
                amendedConfig.testArea.testTimerText        = ''
                amendedConfig.testArea.testTimerIcon        = true
                amendedConfig.testArea.enforceTimeoutAction = false
                amendedConfig.testArea.showMainCatTitle     = false
                amendedConfig.testArea.showSubCatTitle      = this.hasTestStarted || this.isSubCategoryIndexView || this.isBlockIndexView
                amendedConfig.testArea.endBtnTxt            = 'Auswerten'
                amendedConfig.testArea.showQuestionsFilter  = true
                amendedConfig.testArea.showNumbersCtrl      = this.isTestActive && this.isQuestionPresenterView && Question.currentQuestionsCount()>1
                amendedConfig.testArea.showBookmarkCtrl     = this.isTestActive
                amendedConfig.testArea.showLinkToBookmarks  = this.isTestActive

                amendedConfig.preResultsArea.showMainNav            = true
                amendedConfig.preResultsArea.breadCrumbIcon         = imageUrls.navIcons.exerciseIcon
                amendedConfig.preResultsArea.breadCrumbLeftTitle    = 'Übungsmodus'
                amendedConfig.preResultsArea.breadCrumbRightTitle   = Professions.getSelected().title()
                amendedConfig.preResultsArea.showTestDuration       = false
                amendedConfig.preResultsArea.showQuestionsFilter    = true

                amendedConfig.resultsArea.showMainNav           = true
                amendedConfig.resultsArea.breadCrumbIcon        = imageUrls.navIcons.exerciseIcon
                amendedConfig.resultsArea.breadCrumbLeftTitle   = 'Übungsmodus'
                amendedConfig.resultsArea.breadCrumbRightTitle  = Professions.getSelected().title()
                amendedConfig.resultsArea.showTestDuration      = false
                amendedConfig.resultsArea.showMainCatTitle      = false
                amendedConfig.resultsArea.showSubCatTitle       = false
                amendedConfig.resultsArea.showQuestionsFilter   = true
                amendedConfig.resultsArea.showPrevBtn           = !this.isFirstQuestion && this.hasPagination && !this.isSummaryResultsView
                amendedConfig.resultsArea.showNextBtn           = !this.isLastQuestion && this.hasPagination && !this.isSummaryResultsView
                amendedConfig.resultsArea.showBackBtn           = this.isDetailsResultView
                amendedConfig.resultsArea.showBookmarkCtrl      = this.isDetailsResultView
                amendedConfig.resultsArea.showLinkToBookmarks   = this.isDetailsResultView

            return amendedConfig
        },

        testConfig() {
            let amendedConfig = this.baseConfig()
                amendedConfig.testArea.showMainNav              = !this.isTestActive
                amendedConfig.testArea.breadCrumbIcon           = imageUrls.navIcons.testIconGreen
                amendedConfig.testArea.breadCrumbLeftTitle      = 'Testmodus' + this.durationTypeTitle
                amendedConfig.testArea.breadCrumbRightTitle     = Professions.getSelected().title()
                amendedConfig.testArea.showCancelBtn            = !this.hasTestStarted
                amendedConfig.testArea.showBookmarkCtrl         = this.isQuestionPresenterView
                amendedConfig.testArea.showPrevBtn            = (!this.isFirstQuestion && !this.isFirstQuestionInBlock ) && this.isQuestionPresenterView,

                amendedConfig.preResultsArea.showMainNav            = true
                amendedConfig.preResultsArea.breadCrumbIcon         = imageUrls.navIcons.testIconGreen
                amendedConfig.preResultsArea.breadCrumbLeftTitle    = 'Testmodus'
                amendedConfig.preResultsArea.breadCrumbRightTitle   = Professions.getSelected().title()
                amendedConfig.preResultsArea.showMainCatTitle       = !this.isPerformanceSummaryView
                amendedConfig.preResultsArea.showSubCatTitle        = !this.isPerformanceSummaryView

                amendedConfig.resultsArea.showMainNav           = true
                amendedConfig.resultsArea.breadCrumbIcon        = imageUrls.navIcons.testIconGreen
                amendedConfig.resultsArea.breadCrumbLeftTitle   = 'Testmodus'
                amendedConfig.resultsArea.breadCrumbRightTitle  = Professions.getSelected().title()
                amendedConfig.resultsArea.showMainCatTitle      = !this.isMainCategoriesResultsView
                amendedConfig.resultsArea.showSubCatTitle       = this.isSummaryResultsView || this.isDetailsResultView
                amendedConfig.resultsArea.saveTestArea          = true
                amendedConfig.resultsArea.showBookmarkCtrl      = this.isDetailsResultView
                amendedConfig.resultsArea.showLinkToBookmarks   = false

            return amendedConfig
        },

        revisionConfig() {
            let amendedConfig = this.baseConfig()
                amendedConfig.testArea.showMainNav              = true
                amendedConfig.testArea.breadCrumbIcon           = imageUrls.navIcons.statsIcon
                amendedConfig.testArea.breadCrumbLeftTitle      = 'Korrekturbereich'
                amendedConfig.testArea.breadCrumbRightTitle     = Professions.getSelected().title()
                amendedConfig.testArea.showOverallTestTimer     = false
                amendedConfig.testArea.showTestTimer            = false
                amendedConfig.testArea.showBookmarkCtrl         = this.isQuestionPresenterView
                amendedConfig.testArea.showLinkToBookmarks      = this.isQuestionPresenterView
                amendedConfig.testArea.allowReturnToPrevSubCat  = true
                amendedConfig.testArea.showPrevBtn              = this.isQuestionPresenterView && !Question.isFirstQuestionOverall()

                amendedConfig.preResultsArea.showMainNav            = true
                amendedConfig.preResultsArea.breadCrumbIcon         = imageUrls.navIcons.statsIcon
                amendedConfig.preResultsArea.breadCrumbLeftTitle    = 'Korrekturbereich'
                amendedConfig.preResultsArea.breadCrumbRightTitle   = Professions.getSelected().title()
                amendedConfig.preResultsArea.showMainCatTitle       = !this.isPerformanceSummaryView
                amendedConfig.preResultsArea.showSubCatTitle        = !this.isPerformanceSummaryView

                amendedConfig.resultsArea.showMainNav           = true
                amendedConfig.resultsArea.breadCrumbIcon        = imageUrls.navIcons.statsIcon
                amendedConfig.resultsArea.breadCrumbLeftTitle   = 'Korrekturbereich'
                amendedConfig.resultsArea.breadCrumbRightTitle  = Professions.getSelected().title()
                amendedConfig.resultsArea.showMainCatTitle      = !this.isMainCategoriesResultsView
                amendedConfig.resultsArea.showSubCatTitle       = this.isSummaryResultsView || this.isDetailsResultView
                amendedConfig.resultsArea.showBookmarkCtrl      = this.isDetailsResultView
                amendedConfig.resultsArea.showLinkToBookmarks   = true

            return amendedConfig
        },

        revisionResultsConfig() {
            let amendedConfig = this.revisionConfig
                amendedConfig.testArea.breadCrumbLeftTitle      = 'Auswertung'
                amendedConfig.testArea.showCustomTitle          = true
                amendedConfig.testArea.showEvaluationTitle      = false

                amendedConfig.preResultsArea.breadCrumbLeftTitle    = 'Auswertung'
                amendedConfig.preResultsArea.showCustomTitle        = true
                amendedConfig.preResultsArea.showEvaluationTitle    = false

                amendedConfig.resultsArea.breadCrumbLeftTitle   = 'Auswertung'
                amendedConfig.resultsArea.showCustomTitle       = true
                amendedConfig.resultsArea.showEvaluationTitle   = false
            return amendedConfig
        },

        bookmarkRevisionConfig() {
            let amendedConfig = this.baseConfig()
                amendedConfig.testArea.showMainNav          = true
                amendedConfig.testArea.breadCrumbIcon       = imageUrls.navIcons.notepadIcon
                amendedConfig.testArea.breadCrumbLeftTitle  = 'Merkzettel'
                amendedConfig.testArea.breadCrumbRightTitle = Professions.getSelected().title()

                amendedConfig.testArea.showQuestionIndexTop = false
                amendedConfig.testArea.showOverallTestTimer = false
                amendedConfig.testArea.showTestTimer        = false

                amendedConfig.testArea.showNavControls      = false
                amendedConfig.testArea.showPrevBtn          = false
                amendedConfig.testArea.showNextBtn          = false
                amendedConfig.testArea.showGoToCtrl         = false
                amendedConfig.testArea.showCancelBtn        = false
                amendedConfig.testArea.showBackBtn          = true
                amendedConfig.testArea.showEndBtn           = false

                amendedConfig.preResultsArea.showMainNav            = true
                amendedConfig.preResultsArea.breadCrumbIcon         = imageUrls.navIcons.notepadIcon
                amendedConfig.preResultsArea.breadCrumbLeftTitle    = 'Merkzettel'
                amendedConfig.preResultsArea.breadCrumbRightTitle   = Professions.getSelected().title()

                amendedConfig.resultsArea.showMainNav            = true
                amendedConfig.resultsArea.breadCrumbIcon         = imageUrls.navIcons.notepadIcon
                amendedConfig.resultsArea.breadCrumbLeftTitle    = 'Merkzettel'
                amendedConfig.resultsArea.breadCrumbRightTitle   = Professions.getSelected().title()

            return amendedConfig
        },



        durationTypeTitle()
        {
            if(!(this.isRealTest && this.isTestActive)) return ''

            switch(TestTemplate.getSelected().durationType()) {
                case 'kurz':    return ' - kurze Dauer'
                case 'mittel':  return ' - mittlere Dauer'
                case 'lang':    return ' - lange Dauer'
                default:        return ''
            }
        },

        indexOfQuestion()
        {
            return TestResults.isInResultsMode() ? Answer.selectedUserAnswerIndex()
                                                 : Question.selectedIndex()
        },
        isFirstQuestion()           { return this.indexOfQuestion === 0 },
        isFirstQuestionInBlock()    { return this.isRealTest ? Question.isFirstQuestionInBlock() : false },
        isLastQuestion()            { return Question.isLastQuestionReached() },

        hasPagination()
        {
            if(this.isRevisionResults)
                return this.revisionResultsPaginationChecker()

            if(this.isSelfRatingView)
                return this.selfRatingPaginationChecker()

            if(this.isResultsView && this.isRealTest)
                return this.realTestResultsViewPaginationChecker()

            // if(this.isSelfRatingView)
            //     return this.selfRatingPaginationChecker()

            return this.defaultPaginationChecker()
        },
    },

    methods: {
        baseConfig()
        {
            return {
                testArea: {
                    showMainNav:            false,
                    breadCrumbIcon:         imageUrls.navIcons.testIcon,
                    breadCrumbLeftTitle:    'Demoversion',
                    breadCrumbRightTitle:   '',

                    showQuestionIndexTop:   this.hasTestStarted && !this.allQuestionsAtOnce && this.isQuestionPresenterView,
                    showOverallTestTimer:   true,
                    showTestDuration:       false,
                    showTestTimer:          true,
                    testTimerText:          'Zeit',
                    testTimerIcon:          false,
                    enforceTimeoutAction:   true,

                    showMainCatTitle:       this.hasTestStarted,
                    showSubCatTitle:        this.hasTestStarted,

                    showCustomTitle:        false,
                    showSelfRatingTitle:    false,
                    showEvaluationTitle:    false,

                    showNavControls:        this.isTestActive,
                    showQuestionsFilter:    false,
                    showNumbersCtrl:        false,
                    showPrevBtn:            !this.isFirstQuestion && this.isQuestionPresenterView,
                    showNextBtn:            !this.isLastQuestion && this.isQuestionPresenterView,
                    showCancelBtn:          false,
                    showBackBtn:            false,
                    showEndBtn:             this.hasTestStarted,
                    showBuyLicencesBtn:     false,
                    endBtnTxt:              'Beenden',
                    showBookmarkCtrl:       false,
                    showLinkToBookmarks:    false,

                    allowReturnToPrevSubCat:false,
                    saveTestArea:           false,
                },

                preResultsArea: {
                    showMainNav:            false,
                    breadCrumbIcon:         imageUrls.navIcons.testIcon,
                    breadCrumbLeftTitle:    'Demoversion',
                    breadCrumbRightTitle:   '',

                    showTestDuration:       true,

                    showMainCatTitle:       false,
                    showSubCatTitle:        false,

                    showCustomTitle:        false,
                    showSelfRatingTitle:    this.isSelfRatingView,
                    showEvaluationTitle:    !this.isSelfRatingView,

                    showNavControls:        !this.isPerformanceSummaryView,
                    showQuestionsFilter:    false,
                    showNumbersCtrl:        false,
                    showPrevBtn:            !this.isFirstQuestion && this.hasPagination && !this.isPerformanceSummaryView,
                    showNextBtn:            !this.isLastQuestion && this.hasPagination && !this.isPerformanceSummaryView,
                    showCancelBtn:          false,
                    showBackBtn:            false,
                    showEndBtn:             this.isSelfRatingView,
                    showBuyLicencesBtn:     false,
                    endBtnTxt:              'Weiter',
                    showBookmarkCtrl:       false,

                    allowReturnToPrevSubCat:false,
                    saveTestArea:           false
                },

                resultsArea: {
                    showMainNav:            false,
                    breadCrumbIcon:         imageUrls.navIcons.testIcon,
                    breadCrumbLeftTitle:    'Demoversion',
                    breadCrumbRightTitle:   '',

                    showTestDuration:       true,

                    showMainCatTitle:       true,
                    showSubCatTitle:        !this.isMainCategoriesResultsView,

                    showCustomTitle:        false,
                    showSelfRatingTitle:    false,
                    showEvaluationTitle:    true,

                    showNavControls:        !this.isMainCategoriesResultsView,
                    showQuestionsFilter:    false,
                    showNumbersCtrl:        false,
                    showPrevBtn:            !this.isFirstQuestion && this.hasPagination && !this.isMainCategoriesResultsView,
                    showNextBtn:            !this.isLastQuestion && this.hasPagination && !this.isMainCategoriesResultsView,
                    showCancelBtn:          false,
                    showBackBtn:            this.isResultsDetailsView && !this.isMainCategoriesResultsView,
                    showEndBtn:             this.isMainCategoriesResultsView,
                    showBuyLicencesBtn:     false,
                    endBtnTxt:              'Beenden',
                    showBookmarkCtrl:       false,

                    allowReturnToPrevSubCat:false,
                    saveTestArea:           false
                }
            }
        },

        revisionResultsPaginationChecker()
        {
            return Answer.userAnswersCount()>1
        },

        realTestResultsViewPaginationChecker()
        {
            const allResults = TestTemplate.getSelected().allTestQuestions()

            const selectedMainCatResults    = x => x.mainCategoryID === MainCategories.getSelected().id()
            const selectedSubCatResults     = x => x.subCategoryID === SubCategories.getSelected().id()
            const currentMainCatResults     = () => allResults.find(selectedMainCatResults)
            const currentSubCatResults      = () => currentMainCatResults() ? currentMainCatResults().subCategories.find(selectedSubCatResults) : null

            const moreThan1MainCategory = () => allResults.length > 1
            const moreThan1SubCategory  = () => currentMainCatResults() ? currentMainCatResults().subCategories.length > 1 : false
            const moreThan1Question     = () => currentSubCatResults() ? currentSubCatResults().questions.length > 1 : false

            if(this.isSubCategoriesResultsView)
                 return moreThan1MainCategory()

            if(this.isSummaryResultsView)
                return moreThan1SubCategory()

            if(this.isResultsDetailsView)
                return moreThan1MainCategory() || moreThan1SubCategory() || moreThan1Question()
        },

        selfRatingPaginationChecker()
        {
            const getSelfRatedFrom = x => x.filter( q => q.isSelfRated() )

            if(this.isExercise)
                return getSelfRatedFrom(Question.currentQuestions()).length>1

            else if(this.isRealTest)
                return getSelfRatedFrom(TestTemplate.allTestQuestionsAlone()).length>1
        },

        defaultPaginationChecker()
        {
            return Question.currentQuestionsCount()>1
        }
    }
}
